import React, {Component} from 'react';
import config from 'react-global-configuration';
import {Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from 'react-virtualized';
import {disable} from "@amcharts/amcharts4/.internal/core/utils/Debug";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class AdminNewSchemesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      brand_file_uploaded: [],
      mvalue: {year: new Date().getFullYear(), month: 11},
      _notificationSystem: null,
      timer: null,
      loading: true,
      isSubmit: false,
      file_name: "",
      notify: null,
      activer: [],
      activer_copy: [],
      is_download: false,
      uploadDropdown: false,
      errorModel: false,
      noErrorModel: false,
      file_id_got: null,
      report_file_name: null,
      error_message: null,
      error_message_header: null,
      open_instructions: false,
      emiMenus: [],
      party_options: [
        {value: 'Brand', label: 'Brand'},
        {value: 'Merchant', label: 'Merchant'}
      ],
      party_list: [],
      selected_party_type: null,
      selected_party: null,
      selected_party_type2: null,
      selected_party2: null,
      upload_user_type: null,
      partyTypeID: '',
      partyTypeValue: null,
      partyID: '',
      partyValue: null,
      activer2: [],
      update_disabler: false,
      displaySchemeDiv: "none",
      enableDisablePartyType: 'none'
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"/>,
      message: (
        <div>
          {msg}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5
    });
  };

  componentDidMount() {
    this.setState({_notificationSystem: this.refs.notificationSystem});
    this.getPartyID();
    this.getPartyList();
    //var _notificationSystem = this.refs.notificationSystem;
    // this.getBrandUploadedData();
  }

  getPartyID() {
    if ($.fn.DataTable.isDataTable('#party_showTable')) {
      $('#party_showTable').DataTable().destroy();
    }

    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);

    axios.get(config.get('API_URL') + '/brandemi/get_party_id', {
      headers: {
        Authorization: ` ${localStorage.usertoken}`
      },
      params: {
        user_id: decoded._id,
      }
    }).then(response => {
      if (response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')) {
        this.setState({
          party_master_id: 3,
          loading: false,
          user_id: decoded._id
        });
        this.getBrandUploadedData();
      } else {
        //console.log(response.data);
        response.data.map((values, index) => {
          console.log(values.party_id);
          this.setState({
            party_master_id: values.party_id
          })
        })
        this.setState({
          party_id_mapper: response.data
        });
        $('#party_showTable').DataTable();
        this.setState({
          loading: false,
          user_id: decoded._id
        });
        this.getBrandUploadedData();
      }
    });


  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  openInstructions() {
    this.setState({
      open_instructions: !this.state.open_instructions
    });

  }

  onChangeHandler = event => {
    var file = event.target.files[0];
    var ext = this.getFileExtension(file.name);
    if (ext === 'csv') {
      this.setState({
        selectedFile: file,
        file_name: file.name
      });
    } else {
      this.handleNotificationClick("tr", 3, "Please upload valid file");
      this.setState({
        selectedFile: file
      });
    }
  };

  handleChange(checked) {
    console.log(this.state.checked);
    //console.log(e.target.value);
    this.setState({
      checked
    });
    //this.setState({
    //    changedItems: {...this.state.changedItems, [id]:e.target.value},
    //    isChange: true
    //});
  }

  // getBrandUploadedData(){
  //     this.setState({
  //         loading: true
  //     })
  //     if ($.fn.DataTable.isDataTable('#schemesViewTable')) {
  //         $('#schemesViewTable').DataTable().destroy();
  //     }
  //     const token = localStorage.usertoken;
  //     const decoded = jwt_decode(token);
  //     axios.post(config.get('API_URL') + '/brandemi/get_new_schemes_master_filter_paginate', {
  //         party_type: this.state.partyTypeID,
  //         party_id: this.state.partyID
  //     }, {
  //         headers: {
  //             Authorization: ` ${localStorage.usertoken}`
  //         }
  //     }).then(response => {
  //         console.log(response.data.data);
  //         response.data.data.map((value, index) => {
  //             let status = false;
  //             if(value.active===1) { status = true;}
  //             this.setState({
  //                 activer: {...this.state.activer, [value.id]:status }
  //             });
  //         });
  //         this.setState({
  //             //activer_copy: this.state.activer,
  //             brand_file_uploaded: response.data.data,
  //             loading: false
  //         })
  //         $('#schemesViewTable').DataTable({
  //             "oLanguage": {
  //                 "sEmptyTable": "There are no schemes created"
  //             }
  //         });
  //     });
  //     return null;
  // }

  getBrandUploadedData() {

    const that = this;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    var stringCode = decoded.object_code;
    var arrayCode = stringCode.split(",");
    if ($.fn.DataTable.isDataTable('#userTable')) {
      $('#userTable').DataTable().destroy();
    }

    var vEmiFlexyEndPoint = '';
    var vLocEmiType = localStorage.getItem('locFlexipay');

    if (vLocEmiType === '1') {
      vEmiFlexyEndPoint = "get_new_schemes_master_filter_paginate_flexipay";
    } else {
      vEmiFlexyEndPoint = "get_new_schemes_master_filter_paginate";
    }

    var data = {
      party_type: this.state.partyTypeID,
      party_id: this.state.partyID
    }
    var schemeList = $('#schemesViewTable').DataTable(
      {
        order: [],
        "processing": true,
        "serverSide": true,
        "bDestroy": true,
        "paging": true,
        "pageLength": 20,
        "bInfo": true,
        "autoWidth": false,
        "responsive": false,
        "scrollX": true,
        "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],


        ajax: {
          url: config.get('API_URL') + "/brandemi/" + vEmiFlexyEndPoint,
          type: "POST",
          data: data,
          dataSrc: function (json) {
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", localStorage.usertoken);
          },
        },

        columns: [
          {"data": "party_type"},
          {"data": "party_name"},
          {"data": "scheme_name"},
          {"data": "bank_name"},
          {"data": "brand_cb"},
          {"data": "bank_cb"},
          {"data": "post_brand_cb"},
          {"data": "post_bank_cb"},
          {"data": "low_cost_subvention"},
          {"data": "record_update_timestamp"},
          {"data": "active"},
          {"data": "editable"},
          {"data": "id"}
        ],
        "columnDefs": [
          // {

          //     "className":"text-center",
          //     "targets": 5,
          //     "data": "data",
          //     "createdCell": (td, cellData, rowData, row, col) => {
          //         $(td).text('');

          //         if(rowData.org==null || rowData.org=='null' || rowData.org=='') {
          //             $(td).text('');

          //         }
          //         else {
          //             var n = rowData.org.split(",").length;
          //             if (n > 1) {
          //                 var trimmedString = rowData.org.split(",")[0];
          //                 $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View All..</a>');
          //                 $(td).click(e => {
          //                     this.toggleNewOrgModel(e, rowData.org);
          //                 })
          //             } else {
          //                 $(td).append(rowData.org );

          //             }
          //         }
          //     },
          //     bSortable: false,
          // },
          {
            "width": "10%",
            render: function (data, type, row) {
              var id = row.id;
              // var strArray = data.split("_");
              // var id = strArray[8];
              // var status = strArray[1];
              // var active = '';
              // var unlock_icon = '';
              // if (status == 'active') {
              //     active = 'checked';
              // }
              // if(row.event=='account_locked' || row.login_attempts>4){
              //     unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //         '<i class="fa fa-unlock" aria-hidden="true"></i>' +
              //         '</a>';
              // }
              // return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
              //     '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
              //     '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //     '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
              //     '</a>' +
              //     '<label class="switch">' +
              //     '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" class="user_status" ' + active + '>' +
              //     '<span class="slider round"></span>' +
              //     '</label>' + unlock_icon
              //     +
              //     '</td>';
              // return '<td><ReactTooltip className="actionTooltip" place="bottom" type="dark" effect="solid"/>'+
              //         '<Link className="viewButton" data-tip="View Scheme"  to="/admin/admin-new-create-schemes-view/' + id + '"><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>' +
              //         '<Link className="viewButton" data-tip="Edit Scheme"  to="/admin/admin-new-create-schemes-edit/' + id + '"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>' +
              //         '</td>';
              if (row.scheme_type != 'bankemi' && row.scheme_type != 'freeemi') {
                return '<td>' +
                  '<a class="viewButton" data-tip="View Scheme" href="/admin/admin-new-create-schemes-view/' + id + '">' +
                  '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<a class="viewButton" data-tip="Edit Scheme" href="/admin/admin-new-create-schemes-edit/' + id + '">' +
                  '<span class="glyphicon glyphicon-edit" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">' +
                  '</div>' +
                  '</td>';
              } else {
                return '<td>' +
                  '<a class="viewButton" data-tip="View Scheme" href="/admin/admin-new-create-schemes-bank-view/' + id + '" currentitem="false">' +
                  '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">' +
                  '</div>' +
                  '</td>';
              }
            },
            className: "action_button",
            targets: 12,
            aTargets: [-1]
          },
          {
            "width": "10%",
            render: function (data, type, row) {
              var id = row.id;
              // var strArray = data.split("_");
              // var id = strArray[8];
              // var status = strArray[1];
              // var active = '';
              // var unlock_icon = '';
              // if (status == 'active') {
              //     active = 'checked';
              // }
              // if(row.event=='account_locked' || row.login_attempts>4){
              //     unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //         '<i class="fa fa-unlock" aria-hidden="true"></i>' +
              //         '</a>';
              // }
              // return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
              //     '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
              //     '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //     '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
              //     '</a>' +
              //     '<label class="switch">' +
              //     '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" class="user_status" ' + active + '>' +
              //     '<span class="slider round"></span>' +
              //     '</label>' + unlock_icon
              //     +
              //     '</td>';
              // return '<td><ReactTooltip className="actionTooltip" place="bottom" type="dark" effect="solid"/>'+
              //         '<Link className="viewButton" data-tip="View Scheme"  to="/admin/admin-new-create-schemes-view/' + id + '"><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>' +
              //         '<Link className="viewButton" data-tip="Edit Scheme"  to="/admin/admin-new-create-schemes-edit/' + id + '"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>' +
              //         '</td>';
              if (row.active == '1' || row.active == 1) {
                return '<td>Yes</td>';
              } else {
                return '<td>No</td>'
              }
            },
            className: "action_button",
            targets: 10,
            aTargets: [-1]
          },
          {
            "width": "10%",
            render: function (data, type, row) {
              // var strArray = data.split("_");
              // var id = strArray[8];
              // var status = strArray[1];
              // var active = '';
              // var unlock_icon = '';
              // if (status == 'active') {
              //     active = 'checked';
              // }
              // if(row.event=='account_locked' || row.login_attempts>4){
              //     unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //         '<i class="fa fa-unlock" aria-hidden="true"></i>' +
              //         '</a>';
              // }
              // return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
              //     '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
              //     '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
              //     '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
              //     '</a>' +
              //     '<label class="switch">' +
              //     '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" class="user_status" ' + active + '>' +
              //     '<span class="slider round"></span>' +
              //     '</label>' + unlock_icon
              //     +
              //     '</td>';
              // return '<td><ReactTooltip className="actionTooltip" place="bottom" type="dark" effect="solid"/>'+
              //         '<Link className="viewButton" data-tip="View Scheme"  to="/admin/admin-new-create-schemes-view/' + id + '"><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>' +
              //         '<Link className="viewButton" data-tip="Edit Scheme"  to="/admin/admin-new-create-schemes-edit/' + id + '"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>' +
              //         '</td>';
              if (row.editable == '1' || row.editable == 1) {
                return '<td>No</td>';
              } else {
                return '<td>Yes</td>'
              }
            },
            className: "action_button",
            targets: 11,
            aTargets: [-1]
          },
          {
            //  "width": "5%",
              render: function (data) {
                let timer2 = new Date(data)
                timer2.setHours( timer2.getHours() + 5 );
                timer2.setMinutes( timer2.getMinutes() + 30 );
                // timer
                let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');

                return '<td >' + timer3 + '</td>'
              },
              targets: 9,
              aTargets: [-1]
          },
        ]
      });
    // $('#userTable').on('click', 'td.action_button .user_status', function (e) {
    //     e.stopImmediatePropagation();
    //     var id = $(this).data("id");
    //     var status = $(this).data("status");
    //     if (status == "pending") {
    //         alert("Please approve this user");
    //         return false;
    //     }
    //     that.changeStatus(this, id)
    // })
    // $('#userTable').on('click', 'td.action_button a', function (e) {
    //     e.stopImmediatePropagation();
    //     var id = $(this).data("id");
    //     var type = $(this).data("tip");
    //     if (type == 'Delete') {
    //         that.deleteUser(id);
    //     }
    //     if (type == 'Edit') {
    //         that.updUser(id, 'Edit User');
    //     }
    //     if (type == 'Approve') {
    //         that.updUser(id, 'Activate User');
    //     }
    //     if(type == 'Unlock') {
    //         that.unlockUser(id)
    //     }
    // })
  }

  downloadCSV = (file_id, file_value) => {
    this.setState({
      is_download: false
    });
    let xhr = $.ajax({
      url: config.get('API_URL') + "/brandemi/download_csv?file_id=" + file_id,
      type: 'GET',
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", localStorage.usertoken);
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function (response, status, xhr) {
        let blob = new Blob([response], {
          type: "application/csv"
        });
        let fileName = null;
        console.log(file_value);
        console.log(xhr.getResponseHeader('Content-Disposition'));
        if (file_id == '7md38Hhdad3_brand_product_master_template.csv') {
          fileName = 'brand_product_master_template.csv';
        } else {
          fileName = file_value;
        }
        //alert(fileName);
        let rfile = fileName.replace(/\"/g, "");
        // console.log(fileName);
        let a = document.createElement('a');
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = rfile;
        a.click();
        console.log(a);
        window.URL.revokeObjectURL(url);
        this.setState({
          is_download: true
        })
      }.bind(this)
    });
    this.setState({
      xhr: xhr
    })
  };

  downloadReportCSV = (file_id, file_value) => {
    this.setState({
      is_download: false
    });
    let xhr = $.ajax({
      url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
      type: 'GET',
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", localStorage.usertoken);
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function (response, status, xhr) {
        let blob = new Blob([response], {
          type: "application/csv"
        });
        let fileName = file_value;
        console.log(file_value);
        console.log(xhr.getResponseHeader('Content-Disposition'));
        //alert(fileName);
        let rfile = fileName.replace(/\"/g, "");
        // console.log(fileName);
        let a = document.createElement('a');
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = rfile;
        a.click();
        console.log(a);
        window.URL.revokeObjectURL(url);
        this.setState({
          is_download: true
        })
      }.bind(this)
    });
    this.setState({
      xhr: xhr
    })
  };

  fileUploadHandler = () => {
    const timer1 = (Date.now()).toString();
    //console.log(timer1);
    this.setState({
      timer: timer1,
      isSubmit: true,
      loading: true
    });
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    // console.log(decoded);
    const data = new FormData();
    data.append('file', this.state.selectedFile);
    data.append('userID', decoded._id);
    data.append('timer', this.state.timer);
    data.append('timer1', timer1);
    // let random_string = Date.now()+'_'+req.body.userID+'_';
    console.log(decoded.userGroup);
    data.append('userGroup', decoded.userGroup);
    data.append('party_master_id', this.state.party_master_id);
    if (this.state.selectedFile == null) {
      this.handleNotificationClick("tr", 3, "Please upload valid file");
      this.setState({
        isSubmit: false,
        loading: false
      });
    } else {
      var file = this.state.selectedFile; //console.log(data);
      var ext = this.getFileExtension(file.name);
      if (ext === 'csv') {
        axios.post(config.get('API_URL') + "/brandemi/new_upload_scheme_master/", data, {
          headers: {
            Authorization: ` ${localStorage.usertoken}`
          }
        })
          .then(res => {
            console.log(res.data);
            this.setState({
              file_id_got: res.data.file_id,
              report_file_name: res.data.report_file_name
            });
            //console.log(res.data.notify);
            //console.log(res.data.inconsistent);
            if (res.data.flag == 2) {
              this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
            } else if (res.data.flag == 3) {
              this.setState({
                isSubmit: false,
                loading: false,
                notify: res.data.notify,
                file_id_got: res.data.file_id,
                report_file_name: res.data.report_file_name,
                error_message: res.data.total_value + '/' + res.data.total,
                error_message_header: 'Failure'
              });
              this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");

            } else if (res.data.flag == 4) {
              this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
            } else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
              this.setState({
                isSubmit: false,
                loading: false,
                notify: res.data.notify,
                file_id_got: res.data.file_id,
                report_file_name: res.data.report_file_name,
                error_message: res.data.total_value + '/' + res.data.total
              });
              console.log("call show method on success");
              this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
              this.toggleNoErrorModel.bind(this);
              this.setState({
                error_message_header: 'Success'
              })
              this.getBrandUploadedData();
              //this.props.history.push('/admin/brand-product-master')
            } else {
              if (res.data.error2 === 1) {
                this.setState({
                  error_message_header: 'Failure'
                })
                this.getBrandUploadedData();
              } else {
                this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                this.toggleNoErrorModel.bind(this);
                this.setState({
                  error_message_header: 'Success'
                })
                this.getBrandUploadedData();
              }
              this.setState({
                isSubmit: false,
                error_message: res.data.total_value + '/' + res.data.total,
                loading: false,
                notify: res.data.notify,
                file_id_got: res.data.file_id,
                report_file_name: res.data.report_file_name
              });
            }
          })
          .catch(err => {
            console.log(err);// then print response status
            this.handleNotificationClick("tr", 3, "Something Wrong!");
            this.setState({
              isSubmit: false,
              loading: false
            });
            // this.openSectionToMap(true); // remove and place in success block
          })
      } else {
        this.handleNotificationClick("tr", 3, "Please upload valid file");
        this.setState({
          isSubmit: false,
          loading: false
        });
      }
    }
  };

  goBack = () => {
    //this.props.history.push('/admin/brand-emi')
  }

  activeHandler() {
    this.setState({
      isSubmit: true,
      loading: true,
      update_disabler: true
    });
    if (this.state.activer2.length == 0 || this.state.activer2.length == 'undefined') {
      this.handleNotificationClick("tr", 3, "No changes applicable");
      this.setState({
        isSubmit: false,
        loading: false,
        update_disabler: false
      });
    } else {
      const token = localStorage.usertoken;
      const decoded = jwt_decode(token);
      // console.log(decoded);
      const data = new FormData();
      data.append('userID', decoded._id);
      data.append('mappings', JSON.stringify(this.state.activer2));
      data.append('userGroup', decoded.userGroup);
      data.append('party_master_id', this.state.party_master_id);
      axios.post(config.get('API_URL') + "/brandemi/active_updater_scheme", data, {
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
            this.setState({
              isSubmit: false,
              loading: false,
              update_disabler: false
            });
            //this.props.history.push('/admin/brand-product-master')
          } else {
            this.handleNotificationClick("tr", 3, res.data.error);
            this.setState({
              isSubmit: false,
              loading: false,
              update_disabler: false
            });
          }
        })
        .catch(err => { // then print response status
          this.handleNotificationClick("tr", 3, "Something Wrong!");
          this.setState({
            isSubmit: false,
            loading: false,
            update_disabler: false
          })
        })

    }

  };

  changeStatus(id, checked) {
    //let status = 0;
    //if(checked===true){ status = 1 } else { status = 0 }
    this.setState({
      activer2: {...this.state.activer2, [id]: checked},
      activer: {...this.state.activer, [id]: checked}
    })
  }

  uploadDropdownHandler = () => {
    this.setState({
      uploadDropdown: true
    })
  }

  gotoCreateSchemes = () => {
    this.props.history.push('/admin/admin-new-create-schemes-bank');
  }

  getPartyList() {
    const token = localStorage.usertoken;
    axios.post(config.get('API_URL') + '/brandemi/get_party_list_filter', {
        party_type: this.state.partyTypeID
      },
      {
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        }
      })
      .then(response => {
        console.log(response);
        let party_list = [];
        this.setState({
          party_list: [],
          selected_party: null
        });
        response.data.data.map((values, index) => {
          if (values.party_name != 'Admin') {
            party_list.push({value: values.id, label: values.party_name})
          }
        });
        this.setState({
          party_list: party_list,
          loading: false
        })
      });
  }

  toggleErrorModel() {
    this.setState({
      errorModel: !this.state.errorModel
    });
  }

  updatePartyType(optionSelected) {
    this.setState({
      loading: true
    })
    let value = '';
    let partyTypeArray = [];
    if (optionSelected.length < 1) {
      value = null;
      partyTypeArray = '';
    } else {
      optionSelected.map((partytypeids, i) => {
        partyTypeArray.push(partytypeids.value)
      });
    }
    this.setState({
      partyTypeID: partyTypeArray,
      partyTypeValue: optionSelected,
      uploadDropdown: false,
      // partyID: '',
      // partyValue: null,
      party_list: [],
      loading: false,
      //activer: activer_copy
    }, () => {
      this.getPartyList();
      this.getBrandUploadedData();
    });

    // this.setState({
    //     selected_party_type: valuer.value,
    //     selected_party_type2: [{value: valuer.value, label: valuer.label}],

    //     upload_user_type: 7,

    //     selected_party: null,
    //     selected_party2: null,
    //     party_master_id: 5,
    //     party_list: []
    // }, () => {
    //     this.getPartyList();
    // });

  };

  updatePartyValue(optionSelected) {
    this.setState({
      loading: true
    })
    let value = '';
    let partyArray = [];
    if (optionSelected.length < 1) {
      value = null;
      partyArray = '';
    } else {
      optionSelected.map((partyids, i) => {
        partyArray.push(partyids.value)
      });
    }
    this.setState({
      partyID: partyArray,
      partyValue: optionSelected,
      uploadDropdown: false,
      loading: false,
      //activer: activer_copy
    }, () => {
      this.getBrandUploadedData();
    });

    // this.setState({
    //     selected_party: valuer.value,
    //     selected_party2: [{value: valuer.value, label: valuer.label}],
    //     party_master_id: valuer.value,
    //     loading: false,
    //     uploadDropdown: false
    // }, () => {
    //     this.getBrandUploadedData();
    // });
  };

  downloadReport() {
    console.log(this.state.report_file_name);
    this.downloadReportCSV.bind(this, 1, this.state.report_file_name);
  }


  toggleNoErrorModel() {
    this.setState({
      noErrorModel: !this.state.noErrorModel
    });
  }

  gotoUploadedFile = (e) => {
    e.preventDefault();
    let pusher = '/admin/scheme-viewer/' + this.state.file_id_got
    this.props.history.push(pusher)
  }

  _onEmiChecked() {
    this.setState({
      partyTypeValue: [],
      partyValue: [],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'block'
    });

    localStorage.setItem('locFlexipay', '0');

    this.getBrandUploadedData();
  }

  _onFlexypayChecked() {

    this.setState({
      partyTypeValue: [{value: "Brand", label: "Brand"}],
      partyValue: [{value: 35, label: "Default"}],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'none'
    })

    localStorage.setItem('locFlexipay', '1');

    this.getBrandUploadedData();
  }

  render() {
    console.log('this.state.partyTypeValue');
    console.log(this.state.partyTypeValue);

    console.log('this.state.partyValue');
    console.log(this.state.partyValue);

    const MenuList = props => {
      const rows = props.children;
      let no_of_rows = 0;
      let drop_down_heigth = 0
      if (rows.length !== undefined) {
        no_of_rows = rows.length;
        if (no_of_rows < 9) {
          drop_down_heigth = 40 * no_of_rows;
        } else {
          drop_down_heigth = 300;
        }

      }
      const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
        <div key={key} style={style}>{rows[index]}</div>
      );

      return (
        <List
          style={{width: '100%'}}
          width={300}
          height={drop_down_heigth}
          rowHeight={30}
          rowCount={no_of_rows}
          rowRenderer={rowRenderer}
        />
      )
    }
    const customStyles = {
      control: provided => ({
        ...provided,
        padding: "0px",
        minHeight: "15px",
      }),
      indicatorsContainer: provided => ({
        ...provided,
        height: "23px"
      }),
      clearIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      dropdownIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      valueContainer: base => ({
        ...base,
        padding: '0px 6px'
      }),
      menu: styles => ({...styles, zIndex: 999})
    };

    let party_render = this.state.party_options;
    let party_render_list = this.state.party_list;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    let menus = this.state.emiMenus.map((menu, index) => {
      return (
        <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout + menu.path}
                 to={menu.layout + menu.path}>
          {menu.name}
        </NavItem>
      )
    });

    console.log('this.state.enableDisablePartyType');
    console.log(this.state.enableDisablePartyType);

    console.log(this.state.brand_file_uploaded);
    console.log('value.party_name');
    console.log('');

    let brand_file_data = this.state.brand_file_uploaded.map((value, index) => {
      console.log('value.party_name');
      console.log(value.party_name);
      let timer2 = new Date(value.record_update_timestamp)
      timer2.setHours(timer2.getHours() + 5);
      timer2.setMinutes(timer2.getMinutes() + 30);
      // timer
      let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
      let scheme_type = 'Brand EMI';
      if (value.scheme_type == 'exclusiveemi') {
        scheme_type = 'Exclusive EMI';
      } else if (value.scheme_type == 'freeemi') {
        scheme_type = 'Free EMI';
      }

      if (this.state.enableDisablePartyType === 'none' && value.party_name === 'Default') {
        if (value.editable == "1") {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Edit Scheme"
                      to={"/admin/admin-new-create-schemes-edit/" + value.id}><span className="glyphicon glyphicon-edit"
                                                                                    aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        } else {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch disabled={true} className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Unable to edit as scheme in use"><span
                  className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        }
      } else if (this.state.enableDisablePartyType === 'block' && value.party_name !== 'Default') {
        if (value.editable == "1") {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Edit Scheme"
                      to={"/admin/admin-new-create-schemes-edit/" + value.id}><span className="glyphicon glyphicon-edit"
                                                                                    aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        } else {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch disabled={true} className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Unable to edit as scheme in use"><span
                  className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        }
      }

    });

    let error_message = this.state.error_message;
    let error_message_headere = () => {
      let value_header = this.state.error_message_header;
      if (value_header == 'Failure') {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="redtexter">{value_header}</div>
            </div>
          </div>
        );
      } else if (value_header == 'Success') {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="greentexter">{value_header}</div>
            </div>
          </div>
        );
      }
    }

    let party_shower = () => {
      if (decoded.userGroup == 1 || decoded.userGroup == '1') {
        return (
          <div className="row top-margin-30" style={{display: this.state.enableDisablePartyType}}>
            <div className="col-md-3">
              <Label>Select party type</Label>
              <ReactMultiSelectCheckboxes name={"party_type_filter"}
                                          components={{MenuList}}
                                          value={this.state.partyTypeValue}
                                          styles={customStyles} className="report-listbox"
                                          onChange={this.updatePartyType.bind(this)}
                                          options={party_render}
                                          placeholderButtonLabel="Select [Party Type]"
                // isClearable={true}

              />
            </div>
            <div className="col-md-3">
              <Label>Select party</Label>
              <ReactMultiSelectCheckboxes name={"party_name_filter"}
                                          components={{MenuList}}
                                          value={this.state.partyValue}
                                          styles={customStyles} className="report-listbox"
                                          onChange={this.updatePartyValue.bind(this)}
                                          options={party_render_list}
                                          placeholderButtonLabel="Select [Party Name]"
                // isClearable={true}


              />
            </div>
          </div>
        )
      } else {
        return (
          <div></div>
        )
      }
    }

    let link_to_show = () => {
      if (error_message == null) {
        return (<div>
          </div>
        );
      } else {
        if (this.state.error_message_header == 'Failure') {
          return (
            <a href="#" onClick={this.downloadReportCSV.bind(this, 1, this.state.report_file_name)}>View Report</a>
          )
        } else {
          return (
            <a href="#" onClick={this.gotoUploadedFile}>View</a>
          )
        }
      }

    }


    return (
      <div className="longcontent">
        <CommonNavbar/>
        <div className="container-fluid">
          <div className="card" style={{marginBottom: '-2px', paddingLeft: '10px'}}>
            <input type="radio" name="same" onChange={this._onEmiChecked.bind(this)}/><small>EMI</small>
            &nbsp; &nbsp; &nbsp;
            <input type="radio" name="same" onChange={this._onFlexypayChecked.bind(this)}/><small>Flexipay</small>
          </div>

          {/*style={{display:'none'}}*/}
          <div className="card-query-builder top-pad-5" style={{display: this.state.displaySchemeDiv}}>
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ReactTooltip/>
            <Modal isOpen={this.state.noErrorModel}
                   toggle={this.toggleNoErrorModel.bind(this)}
                   size="lg"
            >
              <ModalBody>
                <div className="row">
                  <div className="col-xs-12 ">
                    <h4 className="modalh4">Product details have been successfully uploaded</h4>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" className="btn-capitalize" onClick={this.gotoUploadedFile.bind(this)}>View
                  Uploaded Schemes</Button>{' '}
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.errorModel}
                   toggle={this.toggleErrorModel.bind(this)}
                   size="lg"
            >
              <ModalBody>
                <div className="row">
                  <div className="col-xs-12 ">
                    <h4 className="modalh4">There were errors in your uploaded file</h4>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" className="btn-capitalize" onClick={this.gotoUploadedFile.bind(this)}>View
                  Uploaded Schemes</Button>{' '}
                <Button color="secondary" className="btn-capitalize" onClick={this.downloadReport.bind(this)}>View
                  Report</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.open_instructions}
                   toggle={this.openInstructions.bind(this)}
                   size="lg"
            >
              <ModalHeader>Instructions</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col-md-12">
                    - Keep .csv encoding in UTF-8 format<br/>
                    - Mandatory fields are brand, category, level_1, level_2, sku and mrp<br/>
                    - Keep image url in level_4 (example:
                    https://images-na.ssl-images-amazon.com/images/I/51o5RmQtroL._SL1024_.jpg)
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" className="btn-capitalize"
                        onClick={this.openInstructions.bind(this)}>Close</Button>
              </ModalFooter>
            </Modal>
            <div className="pt-5">
              <div className="card">
                <div className='sweet-loading'>
                  <BeatLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#123abc'}
                    loading={this.state.loading}
                  />
                </div>
                <div className="header">

                  <h4 className="title pull-left">Schemes</h4>
                  <button onClick={this.gotoCreateSchemes} className="btn btn-primary btn-capitalize pull-right">Create
                    new scheme
                  </button>

                </div>

                <div className="content">
                  {party_shower()}
                  <div className="row">
                    <div className="container-fluid">
                      <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">
                        <table className="table table-striped table-hover" id="schemesViewTable">
                          <thead>
                          <tr>
                            <th>Party Type</th>
                            <th>Party Name</th>
                            <th>Scheme Name</th>
                            <th>Bank Name</th>
                            <th>Upfront Cashback Brand</th>
                            <th>Upfront Cashback Bank</th>
                            <th>Post Cashback Brand</th>
                            <th>Post Cashback Bank</th>
                            <th>Low Cost Subvension</th>
                            <th>Time stamp</th>
                            <th>Active</th>
                            <th>In use?</th>
                            <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          {brand_file_data}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                                <div className ="col-md-12">
                                <button onClick={this.activeHandler.bind(this)} disabled={this.state.update_disabler} className="btn btn-primary btn-capitalize pull-right">Update</button>
                                </div>
                            </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminNewSchemesList;